import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { defaultLogo } from "../svg";
import { DefaultLogoContext } from "../../../index";
import { setBackgroundImage } from "../../../../../redux/slices/qrSettings";
import { CustomCol, FrameItem } from "../../framesQr/QrFrameItems";
import { getBase64Logo } from "../../../../../hooks/helpersThirdStep";

function DefaultLogoWrapper({ logoShow }) {
  const backgroundImage = useSelector(
    (state) => state.qrSettings.backgroundImage
  );
  const { setDefaultBackgroundImageData } = useContext(DefaultLogoContext);
  const dispatch = useDispatch();
  async function handlerSubmitLogo(id) {
    dispatch(setBackgroundImage(id));
    const url = await getBase64Logo(id);
    setDefaultBackgroundImageData(url);
  }

  return (
    <>
      {defaultLogo.slice(0, logoShow ? 6 : 7).map((item) => {
        return (
          <CustomCol xs={3} key={item.id}>
            <FrameItem
              onClick={() => handlerSubmitLogo(item.id)}
              className={classNames(
                "d-flex justify-content-center align-items-center border rounded-1",
                {
                  "border-primary": backgroundImage === item.id,
                  "border-border-gray": backgroundImage !== item.id,
                }
              )}
              style={{ padding: "20%" }}
            >
              <img
                src={item.img}
                id={item.id}
                className="img-fluid h-100"
                loading="lazy"
              />
            </FrameItem>
          </CustomCol>
        );
      })}
    </>
  );
}

export default DefaultLogoWrapper;
